import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const RetractIcon = ({ label = 'Retract', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path data-currentcolor="true" d="M29.3 210.4a6 6 0 0 1-1.7-4.4 5.9 5.9 0 0 1 1.7-4.4L145.6 85.2a6.8 6.8 0 0 1 8.8 0l116.3 116.4a5.9 5.9 0 0 1 1.7 4.4 6 6 0 0 1-1.7 4.4l-4.4 4.4a5.7 5.7 0 0 1-4.3 1.6 8.1 8.1 0 0 1-5-1.6L150 107.2 43 214.8a8.1 8.1 0 0 1-5 1.6 5.7 5.7 0 0 1-4.3-1.6z" style="fill:currentColor"/></svg>`}
    />
  )
}

RetractIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { RetractIcon }
